(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skynex-inspect"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('skynex-inspect')){customElements.define('skynex-inspect',class extends HTMLElement{connectedCallback(){if(this.controller)return;this.controller=new AbortController();const opt={signal:this.controller.signal};const film=this.querySelector('.skx-inspect-film');if(film)film.addEventListener('toggle',()=>{if(!film.open)film.querySelector('video').pause();},opt);const stage=this.querySelector('.skx-inspect-stage'),img=this.querySelector('[data-inspect-image]'),range=this.querySelector('[data-inspect-zoom]'),output=this.querySelector('output'),buttons=[...this.querySelectorAll('[data-inspect-src]')];let scale=1,x=0,y=0,drag=null;const draw=()=>{const mx=stage.clientWidth*(scale-1)/2,my=stage.clientHeight*(scale-1)/2;x=Math.max(-mx,Math.min(mx,x));y=Math.max(-my,Math.min(my,y));stage.style.setProperty('--inspect-scale',scale);stage.style.setProperty('--inspect-x',x+'px');stage.style.setProperty('--inspect-y',y+'px');stage.dataset.zoomed=String(scale>1);output.value=Number(scale).toFixed(1)+'×';};const reset=()=>{scale=1;x=y=0;range.value='1';draw();};this.querySelector('.skx-inspect-ui').hidden=false;buttons.forEach((b,i)=>b.addEventListener('click',()=>{img.src=b.dataset.inspectSrc;img.alt=b.dataset.inspectAlt;buttons.forEach(v=>v.setAttribute('aria-pressed',String(v===b)));this.querySelector('[data-inspect-count]').textContent=String(i+1).padStart(2,'0')+' / 03';reset();},opt));range.addEventListener('input',()=>{scale=Number(range.value);draw();},opt);this.querySelector('[data-inspect-reset]').addEventListener('click',reset,opt);stage.addEventListener('pointerdown',e=>{if(scale<=1||e.button!==0)return;drag={id:e.pointerId,x:e.clientX,y:e.clientY,ox:x,oy:y};stage.setPointerCapture(e.pointerId);stage.dataset.dragging='true';},opt);stage.addEventListener('pointermove',e=>{if(!drag||e.pointerId!==drag.id)return;x=drag.ox+e.clientX-drag.x;y=drag.oy+e.clientY-drag.y;draw();},opt);const stop=()=>{drag=null;stage.dataset.dragging='false';};stage.addEventListener('pointerup',stop,opt);stage.addEventListener('pointercancel',stop,opt);stage.addEventListener('lostpointercapture',stop,opt);stage.addEventListener('keydown',e=>{if(e.key==='Escape'){reset();return;}if(scale<=1)return;const map={ArrowLeft:[30,0],ArrowRight:[-30,0],ArrowUp:[0,30],ArrowDown:[0,-30]};if(map[e.key]){e.preventDefault();x+=map[e.key][0];y+=map[e.key][1];draw();}},opt);draw();}disconnectedCallback(){this.querySelectorAll('video').forEach(v=>v.pause?.());this.controller?.abort();this.controller=null;}});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skynex-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.skynexMotion) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let customReduced = false;
  try { customReduced = localStorage.getItem('skynex-reduced-motion') === 'true'; } catch (_) {}
  const activeAnimations = new Set();
  const reduced = () => preference.matches || customReduced;
  const animate = (element, frames, options = {}) => {
    if (!element || reduced() || !element.animate) return;
    const animation = element.animate(frames, { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)', ...options });
    activeAnimations.add(animation);
    animation.finished.then(() => activeAnimations.delete(animation)).catch(() => activeAnimations.delete(animation));
    return animation;
  };
  const syncPreference = () => {
    document.documentElement.dataset.skxReduced = String(reduced());
    if (reduced()) activeAnimations.forEach(animation => animation.cancel());
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(!reduced()));
      button.setAttribute('aria-label', reduced() ? button.dataset.labelOff : button.dataset.labelOn);
    });
  };
  preference.addEventListener('change', syncPreference);
  window.skynexMotion = { reduced, animate };
  class SkynexScene extends HTMLElement {
    connectedCallback() {
      if (this.motionAbort) return;
      this.motionAbort = new AbortController();
      const options = { signal: this.motionAbort.signal };
      this.querySelector('.skx-scene-controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-scene]');
        if (button) {
          if (button.getAttribute('aria-pressed') === 'true') return;
          const buttons = [...this.querySelectorAll('[data-scene]')];
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-scene-panel]').forEach(panel => {
            panel.hidden = panel.dataset.scenePanel !== button.dataset.scene;
            panel.classList.toggle('is-active', !panel.hidden);
            if (!panel.hidden) animate(panel, [{ opacity: .25, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]);
          });
          this.querySelector('[data-scene-count]').textContent = String(buttons.indexOf(button) + 1).padStart(2, '0');
        }
        if (event.target.closest('[data-motion-toggle]')) {
          customReduced = !customReduced;
          try { localStorage.setItem('skynex-reduced-motion', String(customReduced)); } catch (_) {}
          syncPreference();
        }
      }, options);
      const art = this.querySelector('.skx-scene-art');
      art.addEventListener('pointermove', event => {
        if (reduced() || event.pointerType !== 'mouse') return;
        if (this.motionFrame) return;
        this.motionFrame = requestAnimationFrame(() => {
          const rect = art.getBoundingClientRect();
          art.style.setProperty('--light-x', `${Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))}%`);
          art.style.setProperty('--light-y', `${Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100))}%`);
          this.motionFrame = null;
        });
      }, options);
      art.addEventListener('pointerleave', () => { art.style.removeProperty('--light-x'); art.style.removeProperty('--light-y'); }, options);
      animate(this.querySelector('h1'), [{ opacity: .5, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 850 });
      syncPreference();
    }
    disconnectedCallback() { this.motionAbort?.abort(); this.motionAbort = null; cancelAnimationFrame(this.motionFrame); }
  }
  if (!customElements.get('skynex-scene')) customElements.define('skynex-scene', SkynexScene);
  const labels = document.getElementById('skx-motion-labels')?.dataset;
  let detailIndex = 0;
  const initDetails = root => {
    if (!labels) return;
    root.querySelectorAll('.pdp-campaign').forEach(stage => {
      if (stage.dataset.detailReady) return;
      stage.dataset.detailReady = 'true';
      stage.classList.add('skx-detail-stage');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'skx-detail-button'; button.textContent = labels.detail + ' ＋';
      button.setAttribute('aria-expanded', 'false');
      const controls = document.createElement('div');
      controls.className = 'skx-detail-controls'; controls.hidden = true; controls.id = 'skx-detail-' + (++detailIndex);
      button.setAttribute('aria-controls', controls.id);
      const hint = document.createElement('p'); hint.textContent = labels.hint; controls.append(hint);
      const group = document.createElement('div'); group.setAttribute('role', 'group'); group.setAttribute('aria-label', labels.zoom);
      [labels.one, labels.two, labels.three].forEach((label, index) => {
        const level = document.createElement('button'); level.type = 'button'; level.textContent = label;
        level.setAttribute('aria-pressed', String(index === 1));
        level.addEventListener('click', () => {
          stage.style.setProperty('--detail-scale', [1, 1.6, 2.2][index]);
          group.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === level)));
        }); group.append(level);
      });
      controls.append(group); stage.append(button, controls);
      const close = () => { stage.dataset.detailActive = 'false'; controls.hidden = true; button.setAttribute('aria-expanded', 'false'); button.textContent = labels.detail + ' ＋'; };
      button.addEventListener('click', () => {
        if (stage.dataset.detailActive === 'true') { close(); return; }
        stage.dataset.detailActive = 'true'; controls.hidden = false; button.setAttribute('aria-expanded', 'true'); button.textContent = labels.close + ' −';
      });
      stage.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || stage.dataset.detailActive !== 'true') return;
        const rect = stage.getBoundingClientRect();
        stage.style.setProperty('--detail-x', `${Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))}%`);
        stage.style.setProperty('--detail-y', `${Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100))}%`);
      });
      stage.addEventListener('click', event => {
        if (stage.dataset.detailActive !== 'true' || event.target.tagName !== 'IMG') return;
        const rect = stage.getBoundingClientRect();
        stage.style.setProperty('--detail-x', `${(event.clientX - rect.left) / rect.width * 100}%`);
        stage.style.setProperty('--detail-y', `${(event.clientY - rect.top) / rect.height * 100}%`);
      });
      stage.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); button.focus(); } });
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      animate(entry.target, [{ opacity: .45, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }]);
      observer.unobserve(entry.target);
    });
  }, { threshold: .12 }) : null;
  const init = root => {
    initDetails(root);
    root.querySelectorAll('.skx-ritual-copy,.home-section-top,.home-serum-chapter>div,.home-fixora-return article>div,.editorial-card,.product-editorial>div:not(.product-visual)').forEach(element => {
      if (!element.dataset.motionObserved) { element.dataset.motionObserved = 'true'; observer?.observe(element); }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-motion-observed]').forEach(element => observer?.unobserve(element)));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gallery],[data-formula],[data-routine]');
    if (!button) return;
    requestAnimationFrame(() => {
      const id = button.getAttribute('aria-controls');
      const panel = id ? document.getElementById(id) : document.querySelector('[data-formula-panel]:not([hidden])');
      if (panel && !panel.hidden) animate(panel, [{ opacity: .4, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 400 });
    });
  });
  const subnav = document.querySelector('.product-subnav');
  if (subnav) {
    const links = [...subnav.querySelectorAll('a[href^="#"]')];
    const progress = document.createElement('div'); progress.className = 'skx-progress'; progress.setAttribute('aria-hidden', 'true'); document.body.append(progress);
    let pending = false;
    const update = () => {
      pending = false;
      const range = document.documentElement.scrollHeight - innerHeight;
      progress.style.transform = `scaleX(${range > 0 ? Math.max(0, Math.min(1, scrollY / range)) : 0})`;
      let current = null;
      links.forEach(link => { const target = document.getElementById(link.hash.slice(1)); if (target && target.getBoundingClientRect().top < innerHeight * .4) current = link; });
      links.forEach(link => { if (link === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
    };
    window.addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update); update();
  }
  syncPreference();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skynex-ritual-chapters"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('skynex-ritual-chapters'))customElements.define('skynex-ritual-chapters',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opt={signal:this.abort.signal},video=this.querySelector('video'),buttons=[...this.querySelectorAll('[data-chapter]')],error=this.querySelector('[role=status]');let pending=null;const mark=t=>{let active=buttons[0];buttons.forEach(b=>{if(t>=Number(b.dataset.chapter))active=b;});buttons.forEach(b=>{if(b===active)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});};const seek=()=>{if(pending===null)return;const target=pending;pending=null;video.currentTime=target;mark(target);const play=video.play();if(play&&play.catch)play.catch(()=>{error.hidden=false;});};this.querySelector('.skx-chapters-buttons').hidden=false;buttons.forEach(b=>b.addEventListener('click',()=>{error.hidden=true;pending=Number(b.dataset.chapter);if(video.readyState>=1)seek();else{video.preload='metadata';video.load();}},opt));video.addEventListener('loadedmetadata',seek,opt);video.addEventListener('timeupdate',()=>mark(video.currentTime),opt);video.addEventListener('error',()=>{pending=null;error.hidden=false;},opt);document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();},opt);}
 disconnectedCallback(){this.querySelector('video')?.pause();this.abort?.abort();this.abort=null;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skynex-scripts"] && !Shopify.designMode) return;
  try {
    'use strict';
const menu = document.querySelector('.menu-toggle');
const nav = document.getElementById('main-menu');
function setMenu(open, returnFocus = false) {
  nav?.classList.toggle('open', open);
  menu?.setAttribute('aria-expanded', String(open));
  menu?.setAttribute('aria-label', open ? menu.dataset.closeLabel : menu.dataset.openLabel);
  if (menu) { menu.querySelector('[data-menu-label]').textContent = open ? menu.dataset.closeText : menu.dataset.menuText; menu.querySelector('[data-menu-symbol]').textContent = open ? '−' : '＋'; }
  if (returnFocus) menu?.focus();
}
menu?.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
nav?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') {
    setMenu(false, nav?.contains(document.activeElement) || document.activeElement === menu);
  }
});
matchMedia('(min-width:761px)').addEventListener('change', event => { if (event.matches) setMenu(false); });
document.addEventListener('pointerdown', event => { if (menu?.getAttribute('aria-expanded') === 'true' && !nav?.contains(event.target) && !menu.contains(event.target)) setMenu(false); });
document.addEventListener('focusin', event => { if (menu?.getAttribute('aria-expanded') === 'true' && !nav?.contains(event.target) && !menu.contains(event.target)) setMenu(false); });
const openers = new WeakMap();
function openDialog(dialog, opener) {
  if (!dialog || dialog.open) return;
  openers.set(dialog, opener);
  dialog.showModal();
}
document.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => {
  openDialog(document.getElementById(button.dataset.open), button);
}));
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.querySelectorAll('.close,[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    const opener = openers.get(dialog);
    if (opener?.isConnected) opener.focus();
  });
});
document.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
  const image = document.getElementById('enlarged-product');
  image.src = button.dataset.image;
  image.alt = button.dataset.imageDescription;
  document.getElementById('enlarged-caption').textContent = button.dataset.imageDescription;
  openDialog(document.getElementById('image-dialog'), button);
}));
const formulaButtons = [...document.querySelectorAll('[data-formula]')];
formulaButtons.forEach(button => button.addEventListener('click', () => {
  formulaButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  document.querySelectorAll('[data-formula-panel]').forEach(panel => { panel.hidden = panel.dataset.formulaPanel !== button.dataset.formula; });
}));
const routineButtons = [...document.querySelectorAll('[data-routine]')];
routineButtons.forEach(button => button.addEventListener('click', () => {
  routineButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  const sun = document.getElementById('sun-step');
  if (sun) sun.hidden = button.dataset.routine === 'night';
}));
const query = document.getElementById('journal-query');
const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
function filterJournal() {
  if (!query) return;
  const terms = normalize(query.value.trim()).split(/\s+/).filter(Boolean);
  let count = 0;
  document.querySelectorAll('.editorial-card').forEach(card => {
    const text = normalize(card.textContent + ' ' + (card.dataset.search || ''));
    const show = terms.every(term => text.includes(term));
    card.hidden = !show;
    if (show) count++;
  });
  const status = document.getElementById('search-status');
  status.textContent = terms.length ? (count ? `${count} guia${count === 1 ? '' : 's'} encontrado${count === 1 ? '' : 's'}.` : 'Nenhum guia encontrado. Tente “cobre”, “sem perfume” ou “ritual”.') : 'Todos os '+document.querySelectorAll('.editorial-card').length+' guias.';
}
query?.addEventListener('input', filterJournal);
query?.closest('form')?.addEventListener('submit', event => { event.preventDefault(); filterJournal(); });
document.querySelectorAll('[data-query]').forEach(button => button.addEventListener('click', () => {
  if (!query) return;
  query.value = button.dataset.query;
  filterJournal();
  query.focus();
}));
const galleryButtons = [...document.querySelectorAll('[data-gallery]')];
galleryButtons.forEach(button => button.addEventListener('click', () => {
  galleryButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  document.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.gallery; });
}));
  } catch(e) { console.error(e); }
})();

})();
